import { AxiosError } from "axios";

const STOCK_ERROR_PREFIX = "Total proxy count must be less than or equal to";

/**
 * True when a pricing/purchase request was rejected because the requested
 * proxy count exceeds the currently-available stock (the backend caps the
 * count and returns e.g. "Total proxy count must be less than or equal to 50").
 *
 * Unlike {@link isNotProxyAvailabilityError} (which matches only the exact
 * zero-availability message), this matches any over-the-cap response, so it can
 * be used to mark a specific plan tier as out of stock.
 */
export default function isProxyStockError(
  error:
    | AxiosError<{ proxy_countries?: { message?: string }[] }>
    | undefined
    | null
): boolean {
  if (error?.response?.status !== 400) return false;
  const messages = error.response?.data?.proxy_countries;
  if (!Array.isArray(messages)) return false;
  return messages.some(
    (entry) =>
      typeof entry?.message === "string" &&
      entry.message.startsWith(STOCK_ERROR_PREFIX)
  );
}
